module.exports = __webpack_public_path__ + "img/IG_chile.860aea6f.jpg";